import React, {Component} from 'react';
import DateRangeFilter from '../components/DateRangeFilter';
import SecondaryFilter from '../components/SecondaryFilter';
import VIPTrendsReportSet from '../components/VIPTrendsReportSet';
import ReportHeaderState from '../components/ReportHeaderState';
import NoAccess from '../noAccess';
import {RESOURCES as filterResources} from '../fuseFiltersResourceMap';
import {hasReportsAccess} from '../shared/authFunctions';
import {getTimeZoneOffsetDefault} from '../shared/dateTimeLists';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import {Card, CardText} from 'material-ui/Card';
import Avatar from 'material-ui/Avatar';
import Icon from 'material-ui/svg-icons/action/card-membership';

export const fuseVIPTrendsReportsIcon = Icon;

/**
 * VIP Trends Reports class for retrieving and displaying summaries
 *
 */
export class VIPTrendsReports extends Component {
    constructor(props) {
        super(props);
        const system = localStorage.getItem('system');
        const offsetDefault = getTimeZoneOffsetDefault();
        this.state = {
            dataProcessed: false,
            filterChoiceFirst: null,
            filterChoiceSecond: null,
            filterType: 'all',
            filterTypeName: null,
            selectedEndDate: null,
            selectedOffset: offsetDefault,
            selectedStartDate: null,
            system: system,
            totalFiltersAvailable: 0,
        };
    }

    /**
     * Handle event props for initial dataset processing
     *
     */
    handleDataProcessed = () => {
        this.setState({
            dataProcessed: true
        });
    };

    /**
     * Handle event props from DateRangeFilter
     *
     * @param type
     * @param value
     */
    handleDateRangeFilterSelect = (type, value) => {
        switch (type) {
            case 'start_date':
                // Set Start Date selection for reports summary component
                this.setState({selectedStartDate: value});
                break;
            case 'end_date':
                // Set End selection for reports summary component
                this.setState({selectedEndDate: value});
                break;
            case 'offset':
                // Set Time Zone Offset selection for reports summary component
                this.setState({selectedOffset: value});
                break;
            default:
                return
        }
    };

    /**
     * Handle event for Filter type selection
     *
     * @param type
     */
    handleFilterTypeSelect = (type) => {
        this.setState({
            filterChoiceFirst: null,
            filterChoiceSecond: null,
            filterType: type.id,
            filterTypeName: type.name,
            totalFiltersAvailable: 0
        });
    };

    /**
     * Handle event for Secondary Filter selection(s)
     *
     * @param firstChoice
     * @param secondChoice
     */
    handleFilterOptionSelect = (firstChoice, secondChoice) => {
        let filterChoiceFirst = null;
        if (firstChoice) {
            filterChoiceFirst = firstChoice;
        }
        if (secondChoice === 'none') {
            this.setState({
                filterChoiceFirst: filterChoiceFirst,
                filterChoiceSecond: null,
                totalFiltersAvailable: 1
            });
        } else {
            this.setState({
                filterChoiceFirst: filterChoiceFirst,
                filterChoiceSecond: secondChoice,
                totalFiltersAvailable: 2
            });
        }
    };

    render() {
        const {
            dataProcessed,
            filterChoiceFirst,
            filterChoiceSecond,
            filterType,
            filterTypeName,
            selectedEndDate,
            selectedOffset,
            selectedStartDate,
            system,
            totalFiltersAvailable
        } = this.state;

        if (!hasReportsAccess()) return <NoAccess/>;

        const ListTitle = <span className="list-title hide-print">
            <Avatar icon={<Icon/>} className="avatar-title"/>VIP Trends Reports</span>;

        const ListDescription = () => {
            return (
                <span className="list-description hide-print">
                    <p>A VIP Trends Report provides insight into Product quantities purchased by VIP customers, points
                        spent and points earned for a specified date range. Results may be filtered by Location or by
                        VIP Customer.</p>
                    <p>Select a Date Range and Time Zone Offset to generate a Report. You may apply additional filters
                        to further refine results.</p>
                </span>
            );
        };

        let showFilterPrompt = false;
        let showLoading = !!(selectedStartDate && selectedEndDate && selectedOffset);
        if (filterType && filterType !== 'all') {
            if (totalFiltersAvailable === 2 && (!filterChoiceFirst || !filterChoiceSecond)) {
                showFilterPrompt = true;
                showLoading = false;
            } else if (!filterChoiceFirst) {
                showFilterPrompt = true;
                showLoading = false;
            }
        }
        let filterPromptName = (filterTypeName) ? ' for ' + filterTypeName.substr(3) : '';

        return (
            <div className="lists-container">
                <Card>
                    <ViewTitle title={ListTitle}/>
                    <CardText>
                        <ListDescription/>

                        {/* Report Filter (Start Date, End Date, Time Zone) */}
                        <DateRangeFilter
                            onSelectStartDate={this.handleDateRangeFilterSelect}
                            onSelectEndDate={this.handleDateRangeFilterSelect}
                            onSelectOffset={this.handleDateRangeFilterSelect}
                        />

                        {/* Secondary Filters */}
                        {dataProcessed &&
                        <SecondaryFilter
                            startDate={selectedStartDate}
                            endDate={selectedEndDate}
                            offset={selectedOffset}
                            resource={filterResources.VIPTrendsFilterByItems}
                            onFilterTypeSelect={this.handleFilterTypeSelect}
                            onFilterChoiceSelect={this.handleFilterOptionSelect}
                        />
                        }

                        {/* Print Header */}
                        {selectedStartDate && selectedEndDate &&
                        <ReportHeaderState
                            reportType="VIP Trends Report Summary"
                        />
                        }

                        {/* Prompt Messaging */}
                        {showFilterPrompt &&
                        <div className="loader-container">
                            <h4>Please complete a Secondary Filter{filterPromptName}.</h4>
                        </div>
                        }

                        {/* VIP Trends Report Content */}
                        {selectedStartDate && selectedEndDate && selectedOffset &&
                        <div>
                            <VIPTrendsReportSet
                                system={system}
                                startDate={selectedStartDate}
                                endDate={selectedEndDate}
                                offset={selectedOffset}
                                filterType={filterType}
                                filterChoiceFirst={filterChoiceFirst}
                                filterChoiceSecond={filterChoiceSecond}
                                totalFiltersAvailable={totalFiltersAvailable}
                                showLoading={showLoading}
                                onDataProcessed={this.handleDataProcessed}
                            />
                        </div>
                        }
                    </CardText>
                </Card>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/Report/VIPTrendsReports.js